import { BuilderPageOrNavigate } from '../../pages/builder/[page]';

import builderPageIfContent from './builderPageIfContent';

export default function builderPageIfPageContent(fallbackPage) {
  return builderPageIfContent({
    modelName: 'page',
    builderPage: BuilderPageOrNavigate,
    fallbackPage,
  });
}
